<template>
  <div v-if="value" class="data-access-empty-state" :style="overlayStyle">
    <v-card
      :max-width="maxWidth"
      class="text-center pa-8"
      elevation="0"
      outlined
    >
      <v-card-text class="pa-0">
        <v-icon :size="iconSize" :color="iconColor" class="mb-4">
          {{ icon }}
        </v-icon>

        <h3 class="subtitle-1 mb-1 mt-0 pt-0 grey--text text--darken-4">
          {{ title }}
        </h3>

        <p class="body-2 grey--text text--darken-1 mb-2">
          {{ message }}
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "DataAccessEmptyState",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    absolute: {
      type: Boolean,
      default: true,
    },
    opacity: {
      type: Number,
      default: 0.8,
    },
    zIndex: {
      type: Number,
      default: 5,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "mdi-lock",
    },
    iconSize: {
      type: Number,
      default: 48,
    },
    iconColor: {
      type: String,
      default: "primary",
    },
    cardColor: {
      type: String,
      default: "white",
    },
    maxWidth: {
      type: Number,
      default: 500,
    },
  },
  computed: {
    overlayStyle() {
      return {
        position: this.absolute ? "absolute" : "fixed",
        zIndex: this.zIndex,
        backgroundColor: `rgba(255, 255, 255, ${this.opacity})`,
      };
    },
  },
};
</script>

<style scoped>
.data-access-empty-state {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
</style>
